import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** arrow into a tray, download. Decorative line icon; always pair with a visible text label. */
export function DownloadIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 4v11.5" />
      <path d="M7 10.5l5 5 5-5" />
      <path d="M4.5 16.5V19A1.5 1.5 0 0 0 6 20.5h12a1.5 1.5 0 0 0 1.5-1.5v-2.5" />
    </IconSvg>
  )
}
